import _ from 'lodash';

// API_URL is the base URL for API accession set in the configuration.
const apiUrl = () => {
  if (
    process.env.NODE_ENV === 'development' ||
    process.env.NODE_ENV === 'testing'
  ) {
    return process.env.API_URL;
  }
  return _.get(window, 'QRESERVE_PARAMETERS.API_URL');
};
export const API_URL = apiUrl();

// APP_URL is the base URL for webui2 in the configuration.
const appUrl = () => {
  if (
    process.env.NODE_ENV === 'development' ||
    process.env.NODE_ENV === 'testing'
  ) {
    return process.env.APP_URL;
  }
  return _.get(window, 'QRESERVE_PARAMETERS.APP_URL');
};
export const APP_URL = appUrl();

// SAML_URL is the base URL for SAML service accession set in the configuration.
const samlUrl = () => {
  if (
    process.env.NODE_ENV === 'development' ||
    process.env.NODE_ENV === 'testing'
  ) {
    return process.env.SAML_URL;
  }
  return _.get(window, 'QRESERVE_PARAMETERS.SAML_URL');
};

export const SAML_URL = samlUrl();

// STATIC_URL is the location of the application static folder.
const staticUrl = () => {
  if (
    process.env.NODE_ENV === 'development' ||
    process.env.NODE_ENV === 'testing'
  ) {
    return process.env.STATIC_URL;
  }
  return _.get(window, 'QRESERVE_PARAMETERS.STATIC_URL');
};

export const STATIC_URL = staticUrl();

// WEBSOCKET_URL is the websockets location.
const websocketUrl = () => {
  if (
    process.env.NODE_ENV === 'development' ||
    process.env.NODE_ENV === 'testing'
  ) {
    return process.env.WS_URL;
  }
  return _.get(window, 'QRESERVE_PARAMETERS.WS_URL');
};
export const WEBSOCKET_URL = websocketUrl();

// STANDALONE refers to whether or not the application is in standalone mode.
const standaloneMode = () => {
  if (
    process.env.NODE_ENV === 'development' ||
    process.env.NODE_ENV === 'testing'
  ) {
    return process.env.STANDALONE;
  }
  return _.get(window, 'QRESERVE_PARAMETERS.STANDALONE');
};

export const STANDALONE = standaloneMode();
window.STANDALONE = STANDALONE; // Global variable for CI use.

// PORTAL_URL refers to whether or not the application is in standalone mode.
const portalUrl = () => {
  if (
    process.env.NODE_ENV === 'development' ||
    process.env.NODE_ENV === 'testing'
  ) {
    return process.env.PORTAL_URL;
  }
  return _.get(window, 'QRESERVE_PARAMETERS.PORTAL_URL');
};
export const PORTAL_URL = portalUrl();

// THEME_ID allows you to force an always on theme for a particular install
const themeId = () => {
  if (
    process.env.NODE_ENV === 'development' ||
    process.env.NODE_ENV === 'testing'
  ) {
    return process.env.THEME_ID;
  }
  return _.get(window, 'QRESERVE_PARAMETERS.THEME_ID');
};
export const THEME_ID = themeId();

// HIDE_PARTNER_LOGIN allows you to hide the partner login on the login card
const hidePartnerLogin = () => {
  if (
    process.env.NODE_ENV === 'development' ||
    process.env.NODE_ENV === 'testing'
  ) {
    return process.env.HIDE_PARTNER_LOGIN;
  }
  return _.get(window, 'QRESERVE_PARAMETERS.HIDE_PARTNER_LOGIN');
};
export const HIDE_PARTNER_LOGIN = hidePartnerLogin();

const readOnlyMode = () => {
  if (
    process.env.NODE_ENV === 'development' ||
    process.env.NODE_ENV === 'testing'
  ) {
    return process.env.READ_ONLY_MODE;
  }
  return _.get(window, 'QRESERVE_PARAMETERS.READ_ONLY_MODE');
};
export const READ_ONLY_MODE = readOnlyMode();

const sandboxMode = () => {
  if (
    process.env.NODE_ENV === 'development' ||
    process.env.NODE_ENV === 'testing'
  ) {
    return process.env.SANDBOX_MODE;
  }
  return _.get(window, 'QRESERVE_PARAMETERS.SANDBOX_MODE');
};
export const SANDBOX_MODE = sandboxMode();

const ciTestingMode = () => {
  if (window.CI_TESTING) return true;
  if (
    process.env.NODE_ENV === 'development' ||
    process.env.NODE_ENV === 'testing'
  ) {
    return process.env.CI_TESTING;
  }
  return _.get(window, 'QRESERVE_PARAMETERS.CI_TESTING');
};
export const CI_TESTING = ciTestingMode();

// ssoIdpLoginSsoOnly is a map of email domain --> entity ID that constricts
// login to passwordless SSO only.
const ssoIdpLoginSsoOnly = () => {
  if (
    process.env.NODE_ENV === 'development' ||
    process.env.NODE_ENV === 'testing'
  ) {
    return process.env.SSO_IDP_LOGIN_SSO_ONLY;
  }
  return _.get(window, 'QRESERVE_PARAMETERS.SSO_IDP_LOGIN_SSO_ONLY');
};
export const SSO_IDP_LOGIN_SSO_ONLY = ssoIdpLoginSsoOnly();
